var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('h1',{staticClass:"text-xs-center mb-4"},[_vm._v("Page not Found")]),_vm._v(" "),_c('div',{staticClass:"links text-xs-center"},[_c('router-link',{attrs:{"to":{ name: 'welcome' }}},[_vm._v("\n        Go Home\n      ")])],1)])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d66cbe8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/errors/404.vue
// module id = U4Ff
// module chunks = 0